import { rule } from '../../domain/badge-composition-rule.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const mobileRules = composition => {
  const { featureIsEnabled, platformIs, variantIs, planIs, planIsAtLeast, aspectTypeIs, minAspectOffsetTop } = composition.checkers;

  return [
    rule('mobile/mid')
      .when(platformIs('mobile').and(variantIs('mid')))
      .set(() => ({
        aspect: {
          fixedType: 'bottom-right'
        }
      })),

    rule('mobile/mid/expanded')
      .when(platformIs('mobile').and(variantIs('mid')).and(planIs('free').or(aspectTypeIs('expanded'))))
      .set(() => ({
        constraints: {
          hideContainerWhenMinimized: true,
        },
        aspect: {
          fixedType: 'bottom-right'
        },
        parts: {
          sealAsButton: {
            show: true,
            includeBottomText: 'normal'
          }
        }
      })),

    rule('mobile/part/sealButton/close')
      .when(platformIs('mobile').and(variantIs('mid')).and(aspectTypeIs('expanded')))
      .set(() => ({
        parts: {
          sealAsButton: {
            display: 'close'
          }
        }
      })),

    rule('mobile/mid/collapsed')
      .when(platformIs('mobile').and(variantIs('mid')).and(planIsAtLeast('start')).and(aspectTypeIs('collapsed')))
      .set(() => ({
        container: {
          type: 'round-rectangle',
        },
        parts: {
          menu: {
            show: false
          }
        }
      })),

    rule('mobile/part/menu/place/internal')
      .when(platformIs('mobile').and(variantIs('mid')))
      .set(() => ({
        parts: {
          menu: {
            placement: 'internal'
          }
        }
      })),

    rule('mobile/island/expanded/')
      .when(platformIs('mobile').and(variantIs('island').and(aspectTypeIs('expanded'))))
      .set(() => ({
        container: {
          type: 'round-rectangle-concealed-top-left',
        },
        parts: {
          aubySeal: {
            offsetType: 'md',
            offsetBottom: false,
          },
          menu: {
            includeMinimize: true,
            placement: 'internal',
            extraOffsetRight: -28,
          },
          tuvSeal: {
            show: false,
          },
          headerText: {
            type: "minimal",
            minimalOption: "only-authby",
            center: true,
          },
          shadowZone: {
            show: true,
            width: '202px', // same as the seal when not expanded, to make sure this space is kept in the page flow
            height: '59px',
          }
        },
      })),

    rule('mobile/island/expanded/spaceAbove')
      .when(platformIs('mobile').and(variantIs('island')).and(aspectTypeIs('expanded')))
      .when(minAspectOffsetTop(220))
      .set(() => ({
        aspect: {
          hasSpaceAbove: true
        }
      })),

    rule('mobile/position/default')
      .when(variantIs('mid').and(platformIs('mobile')))
      .set(() => ({
        aspect: {
          position: {
            specs: {
              horizontal: {
                distance: 12
              }
            }
          }
        }
      })),

    rule('mobile/header')
      .when(variantIs('header').and(platformIs('mobile')))
      .set(() => ({
        container: {
          type: 'bottom'
        },
        parts: {
          carousel: {
            show: false
          },
          headerText: {
            type: 'brand-link',
            center: false
          },
          menu: {
            includeMinimize: true,
            minimizeAction: 'deactivate'
          }
        }
      })),

    rule('mobile/header/free')
      .when(variantIs('header').and(platformIs('mobile')).and(planIs('free')))
      .set(() => ({
        parts: {
          tuvSeal: {
            show: false
          }
        }
      })),
  ];
};
